import { render } from "./miLoader.vue?vue&type=template&id=53a24f2e&scoped=true"
import script from "./miLoader.vue?vue&type=script&lang=js"
export * from "./miLoader.vue?vue&type=script&lang=js"

import "./miLoader.vue?vue&type=style&index=0&id=53a24f2e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a24f2e"]])

export default __exports__